import { API } from "../../types";

// 定义OpenWeatherMap API返回的数据结构
export interface WeatherData {
  name: string;
  main: {
    temp: number;
    feels_like?: number;
    temp_min?: number;
    temp_max?: number;
    pressure?: number;
    humidity?: number;
  };
  weather?: Array<{
    id?: number;
    main?: string;
    description?: string;
    icon?: string;
  }>;
  wind?: {
    speed?: number;
    deg?: number;
  };
  sys?: {
    country?: string;
    sunrise?: number;
    sunset?: number;
  };
  [key: string]: any;
}

type Data = {
  city: string;
};

export type Props = API<Data>;

export const defaultData: Data = { city: '' };
